module.exports = __webpack_public_path__ + "img/sdk-new-icon.df1c42f.svg";